import { useTheme } from '@emotion/react';
import { CancelToken } from 'apisauce';
import React, { useEffect, useState } from 'react';
import PageHeader from '../../../../components/PageHeader';
import { Box, Button, Dialog, IconButton, Stack, TablePagination, Typography } from '@mui/material';

import appapi from '../../../../api/apiClient';
import { useSelector } from 'react-redux';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { checkPermission } from '../../../../redux/features/authSlice';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import TablePaginationActions from '../../../../components/TablePaginationActions';
import Datatable from '../../../../components/DataTable';
import AccessDenied from '../../AccesDenied/AccessDenied';
import { dialogButtonCancel } from '../../../../utils/commonStyle';
import Details from './Details';
import ClearIcon from '@mui/icons-material/Clear';

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '100%',
    margin: '8px',
    borderRadius: '4px',
    // maxWidth: '736px',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '90%',
  },
};

export default function ViewTraderDetails({ modelOpen, onModelHandleClose, portfolio }) {
  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '5%',
      default: true,
      columnEditable: false,
      activeColumn: true,
    },
    {
      id: 1,
      header: 'ID',
      accessor: 'id',
      width: '10%',
      default: true,
      columnEditable: false,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'radio',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 2,
      header: 'Trader',
      accessor: 'traderName',
      width: '15%',
      default: true,
      capitalize: true,
      columnEditable: false,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'radio',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 3,
      header: 'EUA',
      accessor: 'euaRequired',
      width: '7%',
      default: true,
      capitalize: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'radio',
        typeFilter: true,
        filterList: [],
      },
      Cell: (value) => (
        <Stack
          direction={'row'}
          alignItems={'center'}
        >
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={text}
          >
            {value?.euaRequired ? value.euaRequired?.toLocaleString() : '0'} {value?.tradeType === 'buy' ? '(B)': value?.tradeType === 'sell' ? '(S)' : null}
          </Typography>
        </Stack>
      ),
    },
    {
      id: 4,
      header: 'Price / EUA (€)',
      accessor: 'price',
      width: '23%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'radio',
        typeFilter: true,
        filterList: [],
      },
      Cell: (value) => (
        <Stack
          direction={'row'}
          alignItems={'center'}
          flex={1}
        >
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={text}
            flex={0.3}
          >
            €{' '}
            {(value?.price &&
              parseFloat(value?.price)?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })) ||
              '0'}
          </Typography>
          {value?.priceFlag && value?.stage === 'order' && value?.quoteStatus === 'completed' && (
            <>
              <Typography
                className="fw-regular ff-Roboto fs-12"
                color={value?.priceFlag === 'decrease' ? '#E89300' : '#00A632'}
                flex={0.2}
                alignSelf={'flex-end'}
              >
                {value?.priceFlag === 'decrease' ? '-' : '+'}
                {value?.priceDiference}
                {'%'}
              </Typography>
              {value?.priceFlag === 'decrease' ? <ArrowDownwardIcon style={{ width: '12px', height: '12px', color: '#E89300' }} /> : <ArrowUpwardIcon style={{ width: '12px', height: '12px', color: '#00A632' }} />}
            </>
          )}
        </Stack>
      ),
    },
    {
      id: 5,
      header: 'Total amount',
      accessor: 'totalAmount',
      width: '15%',
      default: true,
      capitalize: true,
      columnEditable: false,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'radio',
        typeFilter: true,
        filterList: [],
      },
      Cell: (value) => (
        <Stack
          direction={'row'}
          alignItems={'center'}
          flex={1}
        >
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={text}
          >
            €{' '}
            {(value?.totalAmount &&
              parseFloat(value?.totalAmount)?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })) ||
              '0'}
          </Typography>
        </Stack>
      ),
    },
    {
      id: 6,
      header: 'Validity',
      accessor: 'validity',
      width: '15%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'radio',
        typeFilter: true,
        filterList: [],
      },
      Cell: (value) => (
        <Stack
          direction={'row'}
          alignItems={'center'}
        >
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={text}
          >
            {(value?.stage !== 'request' && value?.validity && moment(value?.validity).format('DD-MMM-YYYY HH:mm:ss')) || '-'}
          </Typography>
        </Stack>
      ),
    },
    {
      id: 7,
      header: 'Timestamp',
      accessor: 'createdOn',
      width: '15%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'radio',
        typeFilter: true,
        filterList: [],
      },
      Cell: (value) => (
        <div className="flex ">
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={text}
          >
            {moment(value?.createdOn).format('DD-MMM-YYYY HH:mm:ss') || '-'}
          </Typography>
        </div>
      ),
    },
  ];

  const theme = useTheme();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [selectedData, setSelectedData] = useState(null);
  const [tradeList, setTradeList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openRequestForm, setOpenRequestForm] = useState(false);

  const [customerManagementColumn, setCustomerManagementColumn] = useState(columns);

  const { state } = useLocation();

  // useEffect(() => {
  //   if (state?.notificationData) {
  //     setSelectedData(state?.notificationData);
  //     setTimeout(() => {
  //       // handleToggleDrawer();
  //     }, 500);
  //   }
  // }, []);

  const { t } = useTranslation();

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    role: null,
    field: '_id',
    sortOrder: 'desc',
  });

  const { companyDetails, user } = useSelector((state) => state.auth);

  const requestPermission = useSelector((state) => checkPermission(state, 'Trade Management', 'Manage Requests'));
  const approvalPermission = useSelector((state) => checkPermission(state, 'Trade Management', 'Manage Approvals'));

  let source = CancelToken.source();
  const text = theme.palette.primary.text;

  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1, filter: search }));
  };

  const handleToggleDrawer = (noti) => {
    if (noti) {
      setIsDrawerOpen(true);
    } else {
      setIsDrawerOpen(!isDrawerOpen);
    }
  };

  const selectRow = (sitem, sindex) => {
    const users = tradeList.map((item, index) => {
      item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
      item.selected = item._id === sitem._id;
      return item;
    });
    setSelectedData(sitem);
    setTradeList(users);
    setIsDrawerOpen(true);
  };

  const handleGetQuoteList = async (fromSearch = true) => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/trader/portfolioCompletedQuoteList/${user?.companyId}/${portfolio?._id}`,
      {
        pageNumber: payload.page,
        filter: payload.filter ? payload.filter : null,
        pageSize: payload.limit,
        role: payload.role,
        field: payload.field === 'name' ? 'sortName' : payload.field === 'designation' ? 'sortDesignation' : payload.field,

        sortOrder: payload.sortOrder,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          return item;
        });
        setTradeList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.response?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setTradeList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0 }));
        setIsLoading(false);
      }
    } else {
      setTradeList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    if (requestPermission.viewAccess || approvalPermission.viewAccess) {
      handleGetQuoteList();
    }

    return () => {
      if (source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page, payload.filter, payload.field, payload.sortOrder, payload.role]);

  useEffect(() => {
    if (state && state?.notificationData) {
      setSelectedData(state?.notificationData);
      handleToggleDrawer(true);
    }
  }, [state?.notificationData]);

  const handleExcelDownload = async (format) => {
    const response = await appapi.get(
      `/trader/excelPortfolioCompletedQuoteList/${user?.companyId}/${portfolio?._id}`,
      {
        filter: payload.filter ? payload.filter : null,
        role: payload.role,
        field: payload.field === 'name' ? 'sortName' : payload.field === 'designation' ? 'sortDesignation' : payload.field,
        sortOrder: payload.sortOrder,
        format,
        timeZone: moment.tz.guess(true),
      },
      { observe: 'response', responseType: 'blob' },
    );
    if (response.ok) {
      try {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        const ext = format === 'csv' ? 'csv' : 'xlsx';
        link.download = `TRADE${new Date().getTime()}.${ext}`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading:', error);
      }
    } else {
    }
  };

  return requestPermission.viewAccess || approvalPermission.viewAccess ? (
    <Dialog
      sx={sx}
      open={modelOpen}
    >
      <Stack
        style={{ borderBottomWidth: '1px', borderColor: '#BCBCBC' }}
        className="px-[26px] py-[10px]"
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Typography
          className="fs-16 ff-Roboto fw-medium capitalize"
          color={'#1A1A1A'}
        >
          {portfolio?.traderName}
        </Typography>
        <IconButton onClick={() => onModelHandleClose(false)}>
          <ClearIcon style={{ transform: 'scale(1)', color: '#14285A' }} />
        </IconButton>
      </Stack>
      <Stack
        flex={1}
        direction={'row'}
        className="rounded-[8px] bg-white"
      >
        <Stack flex={1}>
          <PageHeader
            handleFilterButton={payload.totalLength > 0 ? true : false}
            handleOnSearchEmit={(search) => {
              handleSearchEmit(search);
            }}
            showExport={payload.totalLength > 0 ? true : false}
            onExport={(type) => {
              handleExcelDownload(type);
            }}
            columnPreference={payload.totalLength > 0 ? true : false}
            columns={customerManagementColumn}
            applyColumnPreference={(c) => setCustomerManagementColumn(c)}
            onRefresh={() => {
              if (payload.page === 1) {
                handleGetQuoteList();
              } else {
                setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1 }));
              }
            }}
          >
            <Stack
              direction="row"
              flex={1}
            >
              {' '}
              <Stack flexGrow={1} />
            </Stack>
          </PageHeader>
          <Stack className="relative overflow-auto flex-auto  h-0">
            <Datatable
              tableHeadBgColor={'#e2eeff'}
              columns={customerManagementColumn.filter((res) => res.activeColumn)}
              data={tradeList || []}
              isLoading={isLoading}
              onClickRow={(item, index) => {
                selectRow(item, index);
              }}
              onChangeFilter={(filterValues) => {
                const sortValues = filterValues?.sort;
                let columnUpdate = customerManagementColumn;
                columnUpdate[filterValues?.id].filter[`selectValue`] = filterValues?.filter.selectValue;
                if (sortValues) {
                  columnUpdate = columnUpdate.map((res) => {
                    return {
                      ...res,
                      sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
                    };
                  });
                }
                setCustomerManagementColumn(columnUpdate);
                if (sortValues) {
                  setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order, role: filterValues?.filter.selectValue }));
                } else {
                  setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, role: filterValues?.filter.selectValue }));
                }
              }}
              sortChange={(sortValues) => {
                const columnUpdate = customerManagementColumn.map((res) => {
                  return {
                    ...res,
                    sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
                  };
                });
                setCustomerManagementColumn([...columnUpdate]);
                setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order }));
              }}
            />
          </Stack>

          <Stack
            sx={{ width: '100%' }}
            className="relative pl-[16px]   inputFormStyle"
            direction={'row'}
          >
            <Button
              sx={[
                dialogButtonCancel,
                {
                  color: theme.palette.primary.main,
                  fontSize: '14px',
                  '&:hover': {},
                },
              ]}
              style={{ width: '230px', height: '48px' }}
              onClick={() => {
                onModelHandleClose();
              }}
            >
              {t('Close')}
            </Button>
            <Box className="flex  justify-end items-center h-[56px] w-[100%] p-[5px]">
              <TablePagination
                sx={{ borderBottom: 0 }}
                rowsPerPageOptions={[]}
                count={payload.totalLength ? payload.totalLength : 0}
                rowsPerPage={payload.limit ? payload.limit : 10}
                page={payload.paginationPage ? payload.paginationPage : 0}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Box>
          </Stack>
        </Stack>
        <Stack>
          {isDrawerOpen && (
            <Details
              trade={selectedData}
              approvalPermission={approvalPermission}
              isDrawerOpen={isDrawerOpen}
              toggleDrawer={() => {
                if (selectedData) {
                  handleToggleDrawer();
                }
              }}
              openEditUser={() => {
                // setAddEditUserOpen(true);
                // setType('edit');
              }}
              init={() => handleGetQuoteList()}
            />
          )}
        </Stack>
      </Stack>
    </Dialog>
  ) : (
    <AccessDenied />
  );
}
